<template>
    <top-view>
        <div class="text-center" style="background:white;height:100%">
            <v-container fluid class="mx-auto text-center">
                <v-row>
                    <p class="profileHeader">{{ $t("web_about") }}</p>
                    <v-divider  class="divider"></v-divider>
                </v-row>
                <v-row align="center" justify="center" class="mt-8">
                    <img src="../../assets/applyvacation_bg.png" height="116" />
                </v-row>
                <v-row align="center" justify="center" class="mt-8">
                    <img src="../../assets/i_vacation.png" height="20" />
                </v-row>
    
                <v-row align="center" justify="center" class="mt-4">
                    <v-col style="max-width:236px;color:#C7C7C7;font-size:1rem;">
                        {{ $t("about_version") }}
                        <v-divider class="mt-6" v-if="false"></v-divider>
                    </v-col>
                </v-row>
                <v-row align="center" justify="center" v-if="false" class="mt-0">
                    <v-col style="max-width:236px;">
                        Tearm of service
                        <v-divider class="mt-4"></v-divider>
                    </v-col>
                </v-row>
                <v-row align="center" justify="center" v-if="false">
                    <v-col style="max-width:236px;">
                        Personal Policy
                        <v-divider class="mt-4"></v-divider>
                    </v-col>
                </v-row>
                <v-row align="center" justify="center" class="mt-13">
                    <v-col>
                        <v-btn @click="backClicked" depressed style="width: 236px;height: 35px;font-size:0.825rem;" color="#E561A9" class="mt-16" dark>
                            <b>{{ $t("web_back") }}</b>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </top-view>
</template>

<script>
import TopView from "../../components/commonui/topView/TopViewFullScreen";
export default {
  components: {
    TopView
  },
  methods: {
    backClicked() {
      this.$router.push({
        name: "home"
      });
    }
  }
};
</script>

<style scoped>
.line-new-vacation {
  box-shadow: 0 0.5px 0 #c7c7c7;
  height: 1px;
  margin-top: 30px;
}

.header-new-vacation {
  font-size: 1.5rem;
  font-weight: bold;
  text-transform: uppercase;
  padding-left: 25px;
}

.col {
  padding: 6px;
}

.profileHeader {
  margin-top: 25px;
  margin-left: 25px;
  width: 142px;
  height: 30px;
  margin-right: 10px;
  text-transform: uppercase;
  color: #333333;
  font: normal normal bold 24px/33px Open Sans;
  white-space: nowrap;
}

.divider {
  margin-top: 50px;
  margin-right: 10px;
}
</style>

